import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PackageDetails } from 'ts/package/interfaces/PackageDetails';
import { getTextAlignStyle } from 'utils/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface AdditionalDetailsProps {
  dealModel: PackageDetails;
  showTopCss?: boolean;
}

const AdditionalDetails: FC<AdditionalDetailsProps> = ({
  dealModel: { deal, description },
  showTopCss,
}) => {
  const [t] = useTranslation();
  return (
    <div className={showTopCss ? '' : 'default-shadow flight-details-item'}>
      <div>
        <div className="text-info">{t('package.category')}</div>
        <div>{deal.roomType}</div>
      </div>
      <div className="mb-20" style={getTextAlignStyle(description.remarks)}>
        <div className="text-lh-sm" dangerouslySetInnerHTML={{ __html: description.remarks }}></div>
      </div>
      <div>
        <div className="text-info">{t('package.taxes')}</div>
        <div>{description.taxes}</div>
      </div>
    </div>
  );
};

export default withErrorBoundary(AdditionalDetails, 'AdditionalDetails');
